import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "preview"
}
const _hoisted_2 = { class: "preview-item" }

import { ref, reactive, onUnmounted } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'FileUploader',
  setup(__props) {

const fileInput = ref<HTMLInputElement | null>(null);
const isDragOver = ref(false);
const files = reactive<{ file: File; preview: string }[]>([]);

const triggerFileInput = () => {
  fileInput.value?.click();
};

const onDragOver = () => {
  isDragOver.value = true;
};

const onDragLeave = () => {
  isDragOver.value = false;
};

const onDrop = (event: DragEvent) => {
  isDragOver.value = false;
  if (event.dataTransfer?.files) {
    addFiles(event.dataTransfer.files);
  }
};

const onFileChange = (event: Event) => {
  const input = event.target as HTMLInputElement;
  if (input.files) {
    addFiles(input.files);
  }
};

const addFiles = (fileList: FileList) => {
  files.splice(0, files.length); // Clear existing files
  for (const file of Array.from(fileList)) {
    const reader = new FileReader();
    reader.onload = (e: ProgressEvent<FileReader>) => {
      files.push({ file, preview: e.target?.result as string });
    };
    reader.readAsDataURL(file);
  }
};

const isImage = (file: { file: File; preview: string }) => {
  return file.file.type.startsWith("image/");
};

const removeFile = (index: number) => {
  URL.revokeObjectURL(files[index].preview);
  files.splice(index, 1);
};

onUnmounted(() => {
  files.forEach((file: { preview: string }) =>
    URL.revokeObjectURL(file.preview)
  );
});

return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["file-upload", { dragover: isDragOver.value }]),
    onDragover: _withModifiers(onDragOver, ["prevent"]),
    onDragleave: _withModifiers(onDragLeave, ["prevent"]),
    onDrop: _withModifiers(onDrop, ["prevent"])
  }, [
    _createElementVNode("input", {
      type: "file",
      ref_key: "fileInput",
      ref: fileInput,
      onChange: onFileChange,
      style: {"display":"none"}
    }, null, 544),
    _createElementVNode("div", {
      class: "upload-area",
      onClick: triggerFileInput
    }, [...(_cache[1] || (_cache[1] = [
      _createElementVNode("span", { class: "material-symbols-outlined upload" }, " upload ", -1),
      _createElementVNode("p", null, [
        _createTextVNode("Drag and drop an image or "),
        _createElementVNode("span", null, "Browse")
      ], -1)
    ]))]),
    (files.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (isImage(files[0]))
              ? (_openBlock(), _createBlock(_component_v_img, {
                  key: 0,
                  src: files[0].preview,
                  alt: "Preview",
                  class: "preview-image"
                }, null, 8, ["src"]))
              : _createCommentVNode("", true),
            _createElementVNode("p", null, _toDisplayString(files[0].file.name), 1),
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (removeFile(0)))
            }, "Remove")
          ])
        ]))
      : _createCommentVNode("", true)
  ], 34))
}
}

})